import styled from '@emotion/styled'

import { MasterDetail, Section, Space } from '../../../../../components/core-v2'
import { TopupWithdrawStepState } from '../../../../trade-editor/modules/01-topup-withdraw/state/topup-withdraw-slice'
import { useAppSelector } from '../../../store/hooks'
import { CollateralAlert } from '../../../util/Alerts'
import { StepName } from '../../00-builder/state/builder-slice'
import { WizardButtons } from '../../00-builder/wizard-buttons'
import { NewNoteState } from '../../01-note/new-note/validation-rules'
import { NoteStepState } from '../../01-note/note/note-step-slice'
import { TermsStepState } from '../../02-terms/state/terms-slice'
import { PortfolioStepState } from '../../03-portfolio/state/portfolio-slice'
import { StrategyStepState } from '../../04-strategy/state/strategy-slice'
import { Charts } from '../../04-strategy/templates/charts'
import { CompleteStepState } from '../complete-slice'
import { Approval } from '../organisms/approval'

export type CompleteStepDumbProps = {
  complete: CompleteStepState
  includeNoteApproval: boolean
  includePortfolioApproval: boolean
  includeStrategyApproval: boolean
  isAllApproved: boolean
  newNote: NewNoteState
  note: NoteStepState
  onFinish: () => void
  onGoToStep: (stepName: StepName) => void
  onMoveBack: () => void
  onSetIsApproved: (stepName: StepName) => void
  portfolio: PortfolioStepState
  strategy: StrategyStepState
  terms?: TermsStepState
  topUpWithdraw?: TopupWithdrawStepState
}

const StyledView = styled.div`
  height: calc(100vh - 184px);
  overflow-y: auto;
`

export function CompleteStepDumb({
  complete,
  includeNoteApproval,
  includePortfolioApproval,
  includeStrategyApproval,
  isAllApproved,
  newNote,
  note,
  onFinish,
  onGoToStep,
  onMoveBack,
  onSetIsApproved,
  portfolio,
  strategy,
  terms,
  topUpWithdraw
}: CompleteStepDumbProps) {
  const isThereAnyChange = Boolean(
    topUpWithdraw ||
      terms ||
      includeNoteApproval ||
      includePortfolioApproval ||
      includeStrategyApproval
  )
  const builderState = useAppSelector(x => x.builder)
  const { userType } = builderState
  const { userRoles } = builderState

  return (
    <MasterDetail
      detailBackground="transparent"
      detailChildren={
        <StyledView>
          <Section my={6} type="primary">
            {strategy && (
              <Charts
                isErrorGeneratingPerformanceChart={strategy.isErrorGeneratingPerformanceChart}
                isErrorGeneratingProjectionChart={strategy.isErrorGeneratingProjectionChart}
                isGeneratingPerformanceChart={strategy.isGeneratingPerformanceChart}
                isGeneratingProjectionChart={strategy.isGeneratingProjectionChart}
                isMoreDataNeeded={!strategy.canProceed}
                performanceMetrics={strategy.performanceMetrics}
                projection={strategy.projection}
              />
            )}
          </Section>
        </StyledView>
      }
      masterBackground="white98"
      masterChildren={
        <StyledView>
          <Section mt={6} px={5} py={6} type="primary">
            <Approval
              complete={complete}
              goToStep={onGoToStep}
              includeNoteApproval={includeNoteApproval}
              includePortfolioApproval={includePortfolioApproval}
              includeStrategyApproval={includeStrategyApproval}
              isThereAnyChange={isThereAnyChange}
              newNote={newNote}
              note={note}
              portfolio={portfolio}
              setIsApproved={onSetIsApproved}
              strategy={strategy}
              terms={terms}
              topUpWithdraw={topUpWithdraw}
            />
          </Section>
          <CollateralAlert />
          {(userType === 'admin' ||
            userType === 'business-unit' ||
            (userType === 'absa' &&
              (userRoles.includes('BankAdmin') || userRoles.includes('Sales')))) && (
            <WizardButtons
              canMoveBack
              canMoveNext={isAllApproved && isThereAnyChange}
              onMoveBack={() => onMoveBack()}
              onMoveNext={() => onFinish()}
            />
          )}
          {userType === 'absa' &&
            !userRoles.includes('BankAdmin') &&
            !userRoles.includes('Sales') && (
              <Space isflex justifyContent="right" my={6}>
                You are not permissioned to submit this trade for approval. Please arrange for a
                permissioned user to submit the trade.
              </Space>
            )}
        </StyledView>
      }
      width="half"
    />
  )
}
